import * as player from '../player.js';
import * as scene from '../scene.js';
import * as loader from '../loader.js';
import * as audio from '../audio.js';
import { Tween } from '../tweens.js'

export {
    init,
}

let moteurSound;

const POIs = [
    {
        name: 'moteur',
        position: { x: 38, y: -8, z: 0 },
        color: 'red',
        radius: 5,
        sound: {
            name: 'moteur-idle',
            gain: 0,
        },
        onStart() {
            audio.panner.play(this);
        },
        collision: {
            radius: 1,
        },
        async onEnter() {
            // Follow player
            moteurSound = await audio.buffers.play('moteur', {
                loop: true,
                gain: 0,
            });
            const originalPosition = { ...this.position };
            new Tween(this.position, player.position, 1, 'easeOutQuad', (v) => {
                this.sound.panner.positionPanner(v.x, v.z, v.y);
            }, (tween) => {
                setTimeout(() => {
                    // Manual cleanup to stop following player
                    tween.dispose();
                    moteurSound.fade();
                    new Tween(this.position, originalPosition, 4, 'easeInOutQuad', (v) => {
                        this.sound.panner.positionPanner(v.x, v.z, v.y);
                    });
                    new Tween(12, 5, 2, 'easeOutQuad', (v) => {
                        this.radius = v;
                    });
                }, 10000);
            });
            // Increase radius to 15
            new Tween(this.radius, 12, 0.5, 'easeOutQuad', (v) => {
                this.radius = v;
            });
        },
    },
];

const sounds = [
    { name: 'moteur-idle', url: new URL('../../sound/Moteur_pause.wav', import.meta.url) },
    { name: 'moteur', url: new URL('../../sound/Moteur.wav', import.meta.url) },
];

const images = [
];

function init() {
    scene.addPOIs(POIs);
    //loader.addImages(images);
    loader.addSounds(sounds);
};
